<script>
/**
 * @component UserAddressSection
 * @description Sección de dirección reutilizable para formularios de paciente y usuario.
 *              Soporta modo dash (Estado/Municipio/Localidad) y modo estándar (Provincia/Localidad/CP).
 * @example <UserAddressSection v-model="patient" :cities="cities" />
 */
import model from "@/mixins/model";
import { PROVINCES } from "@/services/constants";
import { theme } from "@/services/config";
import { capitalize } from "@/services/helper";

export default {
  name: "UserAddressSection",

  props: {
    cities: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
    },
  },

  data() {
    return {
      provinces: PROVINCES,
      theme,
      isLoading: false,
      capitalize,
    };
  },

  mixins: [model],

  methods: {},

  computed: {
    districts() {
      return this.cities?.find(
        (city) => city.name === this.model?.address?.city
      )?.districts;
    },

    neighborhoods() {
      return this.cities
        ?.find((city) => city.name === this.model?.address?.city)
        ?.districts?.find(
          (district) => district.name === this.model?.address?.district
        )?.neighborhoods;
    },
  },
};
</script>

<template lang="pug">
div
  .form-row.form-row--4col
    .form-field
      label.form-field__label Dirección
      el-input(v-model="model.address.street" name="street")
    .form-field
      label.form-field__label Número
      el-input(v-model="model.address.buildingNumber" name="buildingNumber")
    .form-field
      label.form-field__label Número de piso
      el-input(v-model="model.address.apartmentFloor" name="apartmentFloor")
    .form-field
      label.form-field__label Número apartamento
      el-input(v-model="model.address.apartmentNumber" name="apartmentNumber")

  //- Dash custom: Estado / Municipio / Localidad
  .form-row(v-if="theme === 'dash'")
    .form-field
      label.form-field__label
        span.required *
        | Estado
      ValidationProvider(name="localidad" :rules="type === 'user' ? 'required' : ''" v-slot="{ errors }")
        el-select(v-model="model.address.city" placeholder="" name="city" filterable)
          el-option(
            v-for="city in cities"
            :key="city.value"
            :label="capitalize(city.name)"
            :value="city.name"
          )
        span.has-error {{ errors[0] }}
    .form-field
      label.form-field__label
        span.required *
        | Municipio
      ValidationProvider(name="district" :rules="type === 'user' ? 'required' : ''" v-slot="{ errors }")
        el-select(v-model="model.address.district" placeholder="" name="district" filterable)
          el-option(
            v-for="district in districts"
            :key="district.value"
            :label="capitalize(district.name)"
            :value="district.name"
          )
        span.has-error {{ errors[0] }}
    .form-field
      label.form-field__label Localidad
      el-select(v-model="model.address.neighborhood" name="neighborhood" placeholder="" filterable)
        el-option(
          v-for="neighborhood in neighborhoods"
          :key="neighborhood.value"
          :label="capitalize(neighborhood.name)"
          :value="neighborhood.name"
        )

  //- Default: Provincia / Localidad / Código Postal
  .form-row(v-else)
    .form-field
      label.form-field__label
        span.required *
        | Provincia
      el-select#province(v-model="model.address.district" placeholder="" filterable default-first-option)
        el-option(
          v-for="province in provinces"
          :key="province"
          :label="province"
          :value="province"
        )
    .form-field
      label.form-field__label Localidad
      el-input(v-model="model.address.city" name="cityInput")
    .form-field
      label.form-field__label Código Postal
      el-input(v-model="model.address.postalCode")
</template>

<style lang="scss" scoped>
.form-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 12px;
}

.form-row--4col {
  grid-template-columns: repeat(4, 1fr);
}

.form-field {
  min-width: 0;
}

.form-field__label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #6b7294;
  margin-bottom: 4px;

  .required {
    color: #ef4444;
    margin-right: 2px;
  }
}

.has-error {
  color: #ef4444;
  font-size: 12px;
}

.el-select {
  width: 100%;
}
</style>
